export const english = {
    //languages
    english : "English",
    french : "French",
    arabic : "Arabic",
    //navbar
    loading : "Loading",
    home : "Home",
    about : "About",
    services : "Services",
    projects : "Projects",
    contact_nav : "Contact",
    //banner
    text_banner1 : "Discover Aymane Web-Dev's world where your digital\n Ideas transform into captivating web and mobile experiences",
    text_banner2 : "Unlock your online potential with\n An expert web and mobile developer",
    text_banner3 : "Let's craft a stunning Web and mobile application\n That goes beyond just an online presence.",
    button_banner : "Choose your service",
    // modal
    service_title : "Service",
    service_select : "Please choose your service",
    service_select_text : "Would you please enter a valid email address so that you may proceed to the next page",
    service_plugin_maintenance : "Could you please provide the details of your requirements below ? This will enable me to send you a more accurate quote",
    service_textarea_placehoder : "Kindly detail your requirements",
    send : "Send quote",
    close : "Close",
    next_text : "To move to the next page, please select a service and insert a valid email address.",
    //conatct form
    service_contact_first_name : "First name",
    service_contact_last_name : "Last name",
    service_contact_phone : "Phone Number",
    service_contact_email : "Email address",
    service_contact_first_name_placeholder : "Your first name",
    service_contact_last_name_placeholder : "Your last name",
    service_contact_phone_placeholder : "Your Phone Number",
    service_contact_email_placeholder : "Your email address",
    optionnal : "Optional",
    not_optionnal : "Required",
    //services
    ecommerce_service : "Ecommerce Service",
    ecommerce_select : "Please choose your e-commerce service",
    ecommerce_delivery : "Pay on delivery only",
    ecommerce_delivery_crediCard : "Credit card payment and pay on delivery",
    page_add_title : "Add pages",
    multiling_page : "Multilingual page",
    multiling_website : "Multilingual website",
    lang_website : "Language",
    lang_websites : "Languages",
    functionlities_add : "Add functionalities",
    functionlities_select : "Please select a functionality",
    dollar : "USD",
    responsive_service : "Responsive Design",
    newsLetter_service : "News Letter signup",
    seo_service : "SEO Optimization",
    admin_service : "Admin page (Dashbaord page, add, update, delete elements)",
    other_service : "Comment",
    other_discuss : "Write a comment or add other functionalities",
    error : "An error occurred",
    error_language : "All the languages fields are required",
    //service price
    initial_price : "Initial Price",
    initial_price_text : "The initial price includes the homepage, about us page, the contact form,",
    initial_price_text_application : "and all the functionalities of the web application",
    initial_price_text_blog1 : "The initial price includes the homepage, about us page, blog page, contact form, admin page,",
    initial_price_text_blog2 : "and all the functionalities of the blog website",
    initial_price_text_ecommerce1 : "The initial price includes the homepage, about us page, responsive design, contact form,",
    initial_price_text_ecommerce2 : "user login system, checkout page, admin page, and all the functionalities of the e-commerce website",
    initial_price_text_educational1 : "The initial price includes the homepage, about us page, contact form, user login system,",
    initial_price_text_educational2 : "payment implementation, admin page, and all the functionalities of the educational website",
    total_price : "Total Price",
    total_price_text : "The total price does not include taxes",
    total_price_other : "The price for the other services will be added and sent to you later",
    page_add_numbers_title : "Additional Pages",
    page : "page",
    pages : "pages",
    functionalities : "Functionalities",
    //about page
    about_header : "ABOUT ME",
    about_text : "Hello, I'm Aymane Chnaif, and I'm passionate about turning digital ideas into reality.",
    about_text2 : "With a dedicated focus on creating stunning websites and dynamic mobile applications, I have more than three years of proven experience in the world of full-stack web development and mobile app design.",
    about_text3 : "I'm excited to hear about your project ideas and discuss how I can help you achieve your goals. Whether it's a website revamp, a new mobile app, or anything in between, let's collaborate and bring your vision to life.",
    skills : "My key Skills",
    skill_fullStack : "Full-Stack Web Development",
    skill_fullStack_text1 : "I specialize in building end-to-end web solutions, from concept to implementation and deployment.",
    skill_fullStack_text2 : "My expertise spans both front-end and back-end technologies, allowing me to create seamless, user-friendly experiences.",
    skill_mobile : "Mobile Application Development",
    skill_mobile_text : "In addition to web development, I'm proficient in creating mobile applications for both iOS and Android platforms. Whether it's a native or cross-platform app, I have the skills to bring your mobile app idea to life.",
    skill_responsive : "Responsive Design",
    skill_responsive_text : "Ensuring that websites and applications look and perform beautifully across all devices is a top priority. I use responsive design principles to guarantee a seamless experience on smartphones, tablets, and desktops.",
    skill_backEnd : "Back-end Development",
    skill_backEnd_text : "I have experience with server-side technologies, databases, and APIs. I build robust and scalable back-ends to support the functionality of web and mobile applications.",
    skill_ProblemSolving : "Problem Solving",
    skill_ProblemSolving_text : "My strong analytical thinking and problem-solving abilities enable me to efficiently address complex challenges and develop creative, effective solutions.",
    // work with me section
    wokr_with_me : "WHY WORK WITH ME",
    quality_header : "Quality and Precision",
    quality_text : "I take pride in delivering high-quality work with meticulous attention to detail. Your project will be polished.",
    collaborative_header : "Collaborative Approach",
    collaborative_text : "I believe in open communication and collaboration. Your input and feedback are integral to the project's success.",
    onTime_header : "On-Time Delivery",
    onTime_text : "I understand the importance of deadlines. I'm committed to delivering projects on time and within budget.",
    learning_header : "Continuous Learning",
    learning_text : "Technology evolves constantly. I'm committed to staying updated on the latest trends and best practices to provide innovative solutions.",
    //service section
    my_services : "MY SERVICES",
    //project section
    project : "MY PROJECTS",
    link_project : "Link to project",
    additionnal : "Additional projects will be featured on the website in the future",
    //hire section
    hire : "LONG TERM PROJECTS",
    hire_text_1 : "This section is intended for those interested in long-term or medium-term projects, I'm excited to hear about your project ideas ",
    hire_text_2 : "and discuss how I can help you achieve your goals, feel free to reach out to me at the contact information below.",
    forntEnd : "Front-end development Technologies",
    backEnd : "Back-end development Technologies and Database",
    languages : "Languages Spoken",
    languages_arab : "Arabic",
    languages_french : "French",
    languages_english : "English",
    languages_level : "Good knowledge",
    languages_native : "Native language",
    myName : "Aymane Chnaif",
    fullStack : "Full stack engineer",
    //contact section
    contact : "CONTACT ME",
    fullName : "Full name",
    fullName_placeholder : "Your full name",
    subject : "Subject",
    message : "Message",
    file : "Website requirements document",
    file_text : "If you have your website requirements prepared, please kindly share them with me. I will promptly provide you with a quotation",
    send_message : "Send Message",
    //footer section
    phone : "Phone",
    useful_links : "Useful Links",
    terms : "Terms of service",
    privacy : "Privacy policy",
    landing : "Landing pages",
    web : "Web applications",
    mobile : "Mobile applications",
    maintenance : "Website Maintenance",
    plugin : "WordPress plugins",
    copyright : "Copyright",
    rights : "All Rights Reserved",
}